// extracted by mini-css-extract-plugin
export var orderDetails = "_uo-2";
export var orderImage = "_uo-1";
export var orderMeta = "_uo-3";
export var orderSummary = "_uo-0";
export var rightArrow = "_uo-4";